module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card paper"
  }, [_vm._m(0), _vm._v(" "), _c('loader', {
    attrs: {
      "show": _vm.isLoading
    }
  }), _vm._v(" "), (!_vm.isLoading) ? _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "card-row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 col-sm-7 col-md-7 col-lg-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.passport_number),
      expression: "passport_number"
    }],
    staticClass: "row-input",
    attrs: {
      "type": "text",
      "disabled": !_vm.editing,
      "placeholder": "Paspoortnummer"
    },
    domProps: {
      "value": (_vm.passport_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.passport_number = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.hasError('passport_number')) ? _c('small', {
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.hasError('passport_number')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "card-row"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 col-sm-7 col-md-7 col-lg-7"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.country_of_birth),
      expression: "country_of_birth"
    }],
    staticClass: "row-input",
    attrs: {
      "type": "text",
      "disabled": !_vm.editing,
      "placeholder": "Geboorteland"
    },
    domProps: {
      "value": (_vm.country_of_birth)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.country_of_birth = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.hasError('country_of_birth')) ? _c('small', {
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.hasError('country_of_birth')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.city_of_birth),
      expression: "city_of_birth"
    }],
    staticClass: "row-input",
    attrs: {
      "type": "text",
      "disabled": !_vm.editing,
      "placeholder": "Geboorteplaats"
    },
    domProps: {
      "value": (_vm.city_of_birth)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.city_of_birth = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.hasError('city_of_birth')) ? _c('small', {
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.hasError('city_of_birth')))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "card-row"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 col-sm-7 col-md-7 col-lg-7"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.passport_country),
      expression: "passport_country"
    }],
    staticClass: "row-input",
    attrs: {
      "type": "text",
      "disabled": !_vm.editing,
      "placeholder": "Land uitgifte"
    },
    domProps: {
      "value": (_vm.passport_country)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.passport_country = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.hasError('passport_country')) ? _c('small', {
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.hasError('passport_country')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.passport_city),
      expression: "passport_city"
    }],
    staticClass: "row-input",
    attrs: {
      "type": "text",
      "disabled": !_vm.editing,
      "placeholder": "Plaats uitgifte"
    },
    domProps: {
      "value": (_vm.passport_city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.passport_city = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.hasError('passport_city')) ? _c('small', {
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.hasError('passport_city')))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "card-row"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 col-sm-7 col-md-7 col-lg-7"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.date_issue_passport),
      expression: "date_issue_passport"
    }],
    staticClass: "row-input",
    attrs: {
      "type": "text",
      "disabled": !_vm.editing,
      "placeholder": "Datum uitgifte"
    },
    domProps: {
      "value": (_vm.date_issue_passport)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.date_issue_passport = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.hasError('date_issue_passport')) ? _c('small', {
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.hasError('date_issue_passport')))]) : _vm._e()]), _vm._v(" "), _vm._m(5)])])]), _vm._v(" "), _c('div', {
    staticClass: "card-row"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 col-sm-7 col-md-7 col-lg-7"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.passport_expire_date),
      expression: "passport_expire_date"
    }],
    staticClass: "row-input",
    attrs: {
      "type": "text",
      "disabled": !_vm.editing,
      "placeholder": "Geldig tot"
    },
    domProps: {
      "value": (_vm.passport_expire_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.passport_expire_date = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.hasError('passport_expire_date')) ? _c('small', {
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.hasError('passport_expire_date')))]) : _vm._e()]), _vm._v(" "), _vm._m(7)])])]), _vm._v(" "), _c('div', {
    staticClass: "card-row"
  }, [_c('div', {
    staticClass: "col-xs-5 col-sm-5 col-md-5 col-lg-5"
  }, [_c('button', {
    staticClass: "md-btn left",
    class: {
      hide: !_vm.editing
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Annuleren")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 col-sm-7 col-md-7 col-lg-7"
  }, [_c('button', {
    staticClass: "md-btn right",
    class: {
      hide: !_vm.editing
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Opslaan")]), _vm._v(" "), _c('button', {
    staticClass: "md-btn right",
    class: {
      hide: _vm.editing
    },
    on: {
      "click": _vm.edit
    }
  }, [_vm._v("Aanpassen")])])])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-head"
  }, [_c('h3', [_vm._v("\r\n            Paspoortgegevens\r\n            "), _c('i', {
    staticClass: "fa fa-id-card pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-5 col-sm-5 col-md-5 col-lg-5"
  }, [_c('label', {
    staticClass: "title-text"
  }, [_vm._v("Paspoortnummer")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-5 col-sm-5 col-md-5 col-lg-5"
  }, [_c('span', {
    staticClass: "title-text"
  }, [_vm._v("Geboorteplaats")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-5 col-sm-5 col-md-5 col-lg-5"
  }, [_c('span', {
    staticClass: "title-text"
  }, [_vm._v("Plaats uitgifte")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-5 col-sm-5 col-md-5 col-lg-5"
  }, [_c('span', {
    staticClass: "title-text"
  }, [_vm._v("Datum uitgifte")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6"
  }, [_c('small', [_vm._v("dd/mm/jjjj")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-5 col-sm-5 col-md-5 col-lg-5"
  }, [_c('span', {
    staticClass: "title-text"
  }, [_vm._v("Geldig tot")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6"
  }, [_c('small', [_vm._v("dd/mm/jjjj")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64220793"}!./src/templates/passenger/passport.html
// module id = 542
// module chunks = 1